import { useMemo } from 'react';
import { formatTimeZoneOptionLabel, listTimeZoneNames } from './offerTimeZoneConversion';

// Separate from usePersistedDisplayTimeZone: the full labelled list is only needed by the
// selector itself, not by every screen that just reads the current zone (the offer list included).
export function useTimeZoneOptions() {
  return useMemo(
    () => listTimeZoneNames().map((name) => ({ value: name, label: formatTimeZoneOptionLabel(name) })),
    [],
  );
}
